class ImagePreloader {
  static initClass() {
    this.images = {};
  }
  static preload(src, srcset) {
    if (this.images[src]) {
      return;
    }
    return (this.images[src] = new ImagePreloader(src, srcset));
  }

  constructor(src, srcset) {
    this.src = src;
    this.srcset = srcset;
    this.img = new Image();
    this.img.src = this.src;
    this.img.srcset = this.srcset;
  }
}
ImagePreloader.initClass();

jQuery(() => (ProductCatalog.ImagePreloader = ImagePreloader));
